import React from 'react';

const WoodenSpoon = React.createContext({
	ingredients: {},
	units: {},
	recipes: {},
	tags: [],
});

export default WoodenSpoon;